import React from 'react';
import {Navigate} from 'react-router-dom';
import Header from '../../../organisms/header/header.js';
import Footer from "../../../organisms/footer/footer";

import Experience from "../../../organisms/common/experiences/experience";

const RetailerExperience = () => {

  window.scroll(0, 0);


  const token = sessionStorage.getItem('token') || null;
  const loggedUser = JSON.parse(sessionStorage.getItem('loggedUser'));
  const role = loggedUser.role;

  return (
    <>
      {token && (role === 'retailer' || role ==='retailerGM') ? (
        <div className="App">
          <Header/>
          <main className="experience">
            <Experience></Experience>
          </main>
          <Footer/>
        </div>
      ) : (
        <Navigate to="/login"/>
      )}
    </>
  );
};

export default RetailerExperience;
